export default __webpack_public_path__ + "static/media/234.af43e8fa.svg";